__turbopack_export_value__({
  "body-logo-18": "HtmlViewer-module-scss-module__8f9F2a__body-logo-18",
  "body-text-12": "HtmlViewer-module-scss-module__8f9F2a__body-text-12",
  "body-text-14": "HtmlViewer-module-scss-module__8f9F2a__body-text-14",
  "body-text-16": "HtmlViewer-module-scss-module__8f9F2a__body-text-16",
  "body-text-18": "HtmlViewer-module-scss-module__8f9F2a__body-text-18",
  "body-text-20": "HtmlViewer-module-scss-module__8f9F2a__body-text-20",
  "body-text-24": "HtmlViewer-module-scss-module__8f9F2a__body-text-24",
  "body-text-24-2": "HtmlViewer-module-scss-module__8f9F2a__body-text-24-2",
  "body-text-heading-2": "HtmlViewer-module-scss-module__8f9F2a__body-text-heading-2",
  "body-text-heading-3": "HtmlViewer-module-scss-module__8f9F2a__body-text-heading-3",
  "body-text-medium-14": "HtmlViewer-module-scss-module__8f9F2a__body-text-medium-14",
  "body-text-medium-16": "HtmlViewer-module-scss-module__8f9F2a__body-text-medium-16",
  "body-text-medium-18": "HtmlViewer-module-scss-module__8f9F2a__body-text-medium-18",
  "body-text-medium2-18": "HtmlViewer-module-scss-module__8f9F2a__body-text-medium2-18",
  "body-text2-14": "HtmlViewer-module-scss-module__8f9F2a__body-text2-14",
  "body-text2-16": "HtmlViewer-module-scss-module__8f9F2a__body-text2-16",
  "button-primary-text": "HtmlViewer-module-scss-module__8f9F2a__button-primary-text",
  "button-text": "HtmlViewer-module-scss-module__8f9F2a__button-text",
  "button2-text": "HtmlViewer-module-scss-module__8f9F2a__button2-text",
  "card-shadow": "HtmlViewer-module-scss-module__8f9F2a__card-shadow",
  "effect-menu": "HtmlViewer-module-scss-module__8f9F2a__effect-menu",
  "header-1": "HtmlViewer-module-scss-module__8f9F2a__header-1",
  "main-container": "HtmlViewer-module-scss-module__8f9F2a__main-container",
  "main-footer-container": "HtmlViewer-module-scss-module__8f9F2a__main-footer-container",
  "main-header-container": "HtmlViewer-module-scss-module__8f9F2a__main-header-container",
  "txt-12-bold": "HtmlViewer-module-scss-module__8f9F2a__txt-12-bold",
  "txt-14-bold": "HtmlViewer-module-scss-module__8f9F2a__txt-14-bold",
  "txt-14-bold-caps": "HtmlViewer-module-scss-module__8f9F2a__txt-14-bold-caps",
  "txt-14-med": "HtmlViewer-module-scss-module__8f9F2a__txt-14-med",
  "txt-16-bold": "HtmlViewer-module-scss-module__8f9F2a__txt-16-bold",
  "txt-16-med": "HtmlViewer-module-scss-module__8f9F2a__txt-16-med",
  "txt-18-bold": "HtmlViewer-module-scss-module__8f9F2a__txt-18-bold",
  "txt-18-medium": "HtmlViewer-module-scss-module__8f9F2a__txt-18-medium",
  "txt-18-medium-24": "HtmlViewer-module-scss-module__8f9F2a__txt-18-medium-24",
  "txt-24-semi": "HtmlViewer-module-scss-module__8f9F2a__txt-24-semi",
  "viewer": "HtmlViewer-module-scss-module__8f9F2a__viewer",
  "viewer__content": "HtmlViewer-module-scss-module__8f9F2a__viewer__content",
  "viewer__content_block": "HtmlViewer-module-scss-module__8f9F2a__viewer__content_block",
  "viewer__label": "HtmlViewer-module-scss-module__8f9F2a__viewer__label",
});
